export const testimonyData = [
  {
    id: 1,
    avatar: '/assets/images/testimonials/avatar1.jpg',
    name: 'Ebenezer Ntiamoah',
    sex: 'M',
    testimony:
      'This app indeed changes bus transit in Ghana. For once there is an efficient and workable hail riding app for buses. Don\'t get me started on their midroute feature, you can literally purchase a ticket and indicate your pickup point and Voila all at the comfort of your home.'
  },

  {
    id: 2,
    avatar: '/assets/images/testimonials/avatar2.jpg',
    name: 'Mary Larbi',
    sex: 'F',
    testimony:
    'I find this app amazing especially with the emergency contact feature where i could call the police and the ambulance services as well as send my relatives messages with my current location. This is very thoughtful. Kudos.'
  },
  {
    id: 3,
    avatar: '/assets/images/testimonials/avatar3.jpg',
    name: 'Japheth Abrokwah',
    sex: 'M',
    testimony:
      'This Application is so far the best app 👌 I have ever come across, this is because I can now buy a ticket without even going to the station and it has even reduce the amount of money I use when going to the station'
  },
  {
    id: 4,
    avatar: '/assets/images/testimonials/avatar4.jpg',
    name: 'Kwadwo Adusei',
    sex: 'M',
    testimony:
      'Very good initiative. I love the live chart. I tried it and got my reply instantly.'
  }
]
